class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.querySelector('summary');

    /*
     * Hover to open, click to follow the parent link. Gated on a device that
     * genuinely hovers: on touch there is no hover, so a tap would navigate
     * and the submenu could never be reached. Those keep the click-to-open
     * that details gives for free. The inline menu is desktop-only anyway,
     * but a touchscreen laptop is still wide enough to see it.
     */
    this.pointerQuery = window.matchMedia('(hover: hover) and (pointer: fine)');

    this.addEventListener('mouseenter', this.onPointerEnter.bind(this));
    this.addEventListener('mouseleave', this.onPointerLeave.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));
    if (this.summary) this.summary.addEventListener('click', this.onSummaryClick.bind(this));
  }

  get pointerNav() {
    return this.pointerQuery.matches;
  }

  open() {
    this.mainDetailsToggle.setAttribute('open', '');
    if (this.summary) this.summary.setAttribute('aria-expanded', 'true');
  }

  onPointerEnter() {
    if (this.pointerNav) this.open();
  }

  onPointerLeave() {
    if (this.pointerNav) this.close();
  }

  onSummaryClick(event) {
    if (!this.pointerNav) return;

    /*
     * Enter or Space on a focused summary also fires click, but reports a
     * detail of 0. Letting those through keeps the panel reachable by
     * keyboard, which navigating away would otherwise take away.
     */
    if (event.detail === 0) return;

    const href = this.summary.dataset.href;
    if (!href || href === '#') return;

    event.preventDefault();
    window.location.href = href;
  }

  onKeydown(event) {
    if (event.key === 'Escape') this.close();
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
